import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  selector: "app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal
  ) { }
  @Input() public errorDescription?: string;
  @Input() public errorName?: string;
  @Input() public showCancelButton: boolean = false;
  @Input() public confirmBtnText = "Confirm";
  ngOnInit() { }
}

